export default {
  BusinessLogisticsCompanyPostCode: {
    country: 'Country',
    state: 'State',
    suburb: 'Suburb',
    postcode: 'Post Code',
    dataFormTitle_Add: 'Add Post Cost',
    dataFormTitle_Edit: 'Edit Post Code',
    label: 'Label',
    labelSub: 'LabelSub',
    zone: 'Zone',
    ps1: 'The Start Postcode cannot be greater than the End Postcode!',
  }
};
